<template>
  <div class="certication">
    <!-- <div>{{ adddbegin }}</div> -->

    <div class="TechnicalParameters">{{ $t("login.teparnters") }}</div>
    <div class="volltage">
      <div class="fontleft">
        <div class="Certification" v-for="item in adddbegin" :key="item.id">
          <!-- Certification: ETL -->
          <div>{{ item.name }}:</div>
          <div class="rightcontent">
            {{ item.content }}
          </div>
        </div>
        <!-- <div class="Certification">Voltage: 120V/60Hz</div>
        <div class="Certification">Illumination Power (W*1): 3X2（LED）</div>
        <div class="Certification">Motor Power (W): 256</div>
        <div class="Certification">Gas Sensor: N</div>
        <div class="Certification">Wind Curtain: N</div>
        <div class="Certification">Intelligent Air Management: N</div>
        <div class="Certification">Anion Sterilization: N</div>
        <div class="Certification">Net Weight (kg): N</div>
        <div class="Certification">Packing-Box Size (mm): N</div> -->
      </div>
      <div class="fontright">
        <div class="Certification" v-for="item in adddend" :key="item.id">
          <div>{{ item.name }}:</div>
          <div class="rightcontent">
            {{ item.content }}
          </div>
        </div>
        <!-- <div class="Certification">Noise Level (Sones): <56.5dB</div>
        <div class="Certification">Air Flow (m³/h): N</div>
        <div class="Certification">Filter: Integral grille mesh</div>
        <div class="Certification">Heat Sensor: N</div>
        <div class="Certification">Auto Turbo System: N</div>
        <div class="Certification">Smoke Sound Detection: N</div>
        <div class="Certification">Central Energy Cursor: N</div>
        <div class="Certification">Gross Weight (kg): N</div>
        <div class="Certification">Volume (m³): N</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["param"],

  data() {
    return {};
  },
  created() {
    console.log(this.param);
  },
  computed: {
    adddbegin: function () {
      // return this.param.slice(0, this.param.length / 2);
      // return this.param.slice(0, 15);
      console.log(this.param.length % 2);
      if (this.param.length % 2 == 0) {
        return this.param.slice(0, this.param.length / 2);
      } else {
        return this.param.slice(0, this.param.length / 2 + 1);
      }
    },
    adddend: function () {
      // return this.param.slice(this.param.length / 2 + 1, this.param.length);
      // return this.param.slice(16, 30);
      if (this.param.length % 2 == 0) {
        return this.param.slice(this.param.length / 2, this.param.length);
      } else {
        return this.param.slice(this.param.length / 2 + 1, this.param.length);
      }
    },
  },
  mounted() {
    console.log(this.param);
  },
};
</script>
<style lang="less" scoped>
.certication {
  width: 1200px;
  display: flex;
  margin: 0 auto;
  margin-bottom: 47px;
  flex-direction: column;
  .TechnicalParameters {
    font-size: 18px;
    font-family: Arial;
    font-weight: bold;
    margin-top: 40px;
    color: #000000;
  }
  .volltage {
    margin-top: 40px;
    display: flex;
    .fontleft {
      width: 48%;
      display: flex;
      border-top: 1px solid #f2f2f2;
      flex-direction: column;
      .Certification {
        font-size: 14px;
        font-family: Arial;
        font-weight: 400;
        color: #606060;
        line-height: 80px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f2f2f2;
      }
    }
    .fontright {
      width: 48%;
      display: flex;
      border-top: 1px solid #f2f2f2;
      flex-direction: column;
      margin-left: 20px;
      .Certification {
        font-size: 14px;
        font-family: Arial;
        font-weight: 400;
        color: #606060;
        line-height: 80px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f2f2f2;
      }
    }
  }
}
.rightcontent {
  margin-right: 20px;
}
</style>